<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/order/list' }" replace>
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span
          class="ivu-page-header-title mr20">查看订单</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Steps :current="orderDetails.status" v-if="orderDetails.status < 4">
        <Step title="待支付"></Step>
        <Step title="待发货"></Step>
        <Step title="待收货"></Step>
        <Step title="已完成"></Step>
      </Steps>
      <Steps :current="1" v-else-if="orderDetails.status === 4">
        <Step title="待支付"></Step>
        <Step title="已取消"></Step>
      </Steps>
    </card>
<!--    <Button type="primary" style="margin-top: 20px" v-if="orderDetails.status===1" @click="delivery(orderDetails)">发送货</Button>-->
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form label-position="right" :label-width="120">
        <Row>
          <span><h3>收货信息</h3></span>
          <Col span="8">
            <form-item label="收货人：">
              {{orderDetails.receiver_name}}
            </form-item>
            <form-item label="联系电话：">
              {{orderDetails.receiver_phone}}
            </form-item>
          </Col>
          <Col span="8">
            <form-item label="收货地址：">
              {{orderDetails.address}}
            </form-item>
            <form-item label="物流单号：">
              {{orderDetails.logistics_no}}
              <Button v-if="orderDetails.delivery_status===1" type="primary" :loading="loadingLogistics" style="display: inline-block" @click="orderLogistics(orderDetails.order_id)">物流信息</Button>
            </form-item>
          </Col>
        </Row>
        <Divider />
        <Row>
          <span><h3>订单信息</h3></span>
          <Col span="8">
            <form-item label="订单编号：">
              {{orderDetails.order_sn}}
            </form-item>
            <form-item label="备注：">
              {{orderDetails.remarks}}
            </form-item>
            <form-item label="支付时间:">
              {{orderDetails.pay_time}}
            </form-item>
          </Col>
          <Col span="8">
            <form-item label="订单状态：" style="color:red">
              <span v-if="orderDetails.status==0">待支付</span>
              <span v-else-if="orderDetails.status==1">待发货</span>
              <span v-else-if="orderDetails.status==2">待收货</span>
              <span v-else-if="orderDetails.status==3">待评价</span>
              <span v-else-if="orderDetails.status==4">已完成</span>
              <span v-else-if="orderDetails.status==5">已取消</span>
            </form-item>
            <form-item label="下单时间:">
              {{orderDetails.ctime}}
            </form-item>
          </Col>
          <Col span="8">
            <form-item label="发货状态:" style="color:blue">
              <span v-if="orderDetails.delivery_status===0">待发货</span>
              <span v-else-if="orderDetails.delivery_status===1">已发货</span>
              <span v-else-if="orderDetails.delivery_status===2">商家配送</span>
            </form-item>
            <form-item label="实际支付:">
              <span>￥{{orderDetails.total_fee}}</span>
            </form-item>
          </Col>
          <Col span="24">
            <form-item>
              <Table :columns="columns1" :data="goodsInfo">
                <template slot-scope="{ row, index }" slot="cover">
                  <div class="tabBox_img">
                    <img :src="row.cover " v-if="row.cover!== ''">
                    <span v-else></span>
                  </div>
                </template>
                <template slot-scope="{ row, index }" slot="status">
                  <span v-if="row.status === 1" style="color: #13a702">正常</span>
                  <span v-else style="color: #f80606">有退款</span>
                </template>

                <template slot-scope="{ row, index }" slot="price">
                  <span>￥{{row.price}}</span>
                </template>
              </Table>
            </form-item>
          </Col>
        </Row>
      </Form>
    </Card>

    <!--发送货-->
    <orderEdit ref="orderEdit" :editShow="editShow" :id="order_id" @updateStatusModel="updateStatusModel"></orderEdit>

    <!-- 物流信息 -->
    <Modal v-model="showLogistics" title="物流信息" width="50">
      <!-- 展示物流节点信息 -->
      <div style="font-size: 15px;margin-bottom: 10px;font-weight: bold;">
        {{orderDetails.logistics_com}} {{orderDetails.logistics_no}}
      </div>
      <div v-if="logisticsData.length > 0" style="width: 100%; max-height: 400px; overflow-y: auto;">
        <div v-for="(item, index) in logisticsData" :key="index">
          <div style="margin-bottom: 10px;">
            <div style="font-size: 14px;">{{ item.ftime }}</div>
            <p style="text-indent: 10px; margin-left: 10px;">{{ item.context }}</p>
          </div>
        </div>
      </div>
    </Modal>

  </div>

</template>
<script>
import {getLogisticsApi, orderInfo, orderLogisticsApi} from '@/api/order'
import orderEdit from './components/orderEdit'
export default {
  name: 'orderInfo',
  components: { orderEdit },
  inject: ['reload'],
  data () {
    return {
      showLogistics: false,
      loadingLogistics: false,
      logisticsData: [],

      visible: false,
      orderDetails: [],
      orderInvoice: [],
      editShow: false,
      order_id: 0,
      columns1: [
        {
          title: '商品名称',
          key: 'goods_title'
        },
        {
          title: '封面图',
          slot: 'cover'
        },
        {
          title: '单价',
          slot: 'price'
        },
        {
          title: '数量',
          key: 'num'
        },
        {
          title: '状态',
          slot: 'status'
        }

      ],
      goodsInfo: []
    }
  },
  created () {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.order_id = this.$route.params.id
      this.orderInfo()
    }
  },
  mounted () {
  },
  methods: {
    orderInfo () {
      orderInfo({ 'order_id': this.order_id }).then(res => {
        this.orderDetails = res.data
        this.orderInvoice = this.orderDetails.orderInvoice
        this.goodsInfo = this.orderDetails.orderDetail
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    },
    delivery (row) {
      this.order_id = row.order_id
      this.editShow = true
    },

    // 查询订单物流信息
    orderLogistics (id) {
      this.loadingLogistics = true
      getLogisticsApi(id).then(res => {
        this.logisticsData = res.data
        this.showLogistics = true
        this.loadingLogistics = false
      }).catch(res => {
        this.loadingLogistics = false
        this.$Message.error(res.msg)
      })
    },
  }
}
</script>
